import Alpine from 'alpinejs'
import Swiper from 'swiper'
import Plyr from 'plyr'

import lazy from './utils/lazy.js'
import htmxEvents from './utils/htmx-events.js'
import swiper from './utils/swiper.js'
import refreshCsrfToken from './utils/refresh-csrf-token.js'
import refreshFormieTokens from './utils/refresh-formie-tokens.js'
import plyr from './utils/plyr.js'
import audioTranscription from './utils/audio-transcription.js'
import wrappingElements from './utils/wrapping-elements.js'
import lightbox from './utils/lightbox.js'
import equalizeInlineFilters from './utils/equalize-inline-filters.js'
import newsletterPopup from './utils/newsletter-popup.js'
import scrollReveal from './utils/scroll-reveal.js'
import { pxToRem, pxToRemUnit } from './utils/px-to-rem.js'

window.pxToRem = pxToRem
window.pxToRemUnit = pxToRemUnit


wrappingElements.init(Alpine)
lightbox.init(Alpine)
Alpine.start()

// Attach early so we don't miss `onFormieInit` if Formie boots before
// our DOMContentLoaded handler runs.
refreshFormieTokens.init();

document.addEventListener("DOMContentLoaded", () => {
    new ResizeObserver(() => {
        let vw = document.documentElement.clientWidth / 100;
        document.documentElement.style.setProperty('--vw', `${pxToRem(vw)}rem`);
    }).observe(document.documentElement);

    htmxEvents.init()
    swiper.init()
    lazy.init()
    refreshCsrfToken.init();
    plyr.init();
    audioTranscription.init();
    equalizeInlineFilters.init();
    newsletterPopup.init();
    scrollReveal.init();

    // Re-init JS components after HTMX swaps into the slideout
    document.addEventListener('htmx:afterSettle', (event) => {
        const target = event.detail.target;
        if (!target || target.id !== 'slideout-content') return;

        target.querySelectorAll('.swiper').forEach(el => {
            const handle = el.dataset.swiperHandle ?? 'default';
            const config = { ...swiper.config[handle] };
            const instance = new Swiper(el, config);

            if (handle === 'imageCarouselAlt') {
                swiper.updateCarouselHeight(el);
                instance.update();
            }

            swiper.activeSwipers.push(instance);
        });

        target.querySelectorAll('.js-player').forEach(el => {
            plyr.playerInstances.push(new Plyr(el));
        });

        // Re-init audio transcription within slideout
        const audioRoot = target.querySelector('[data-audio-transcription]');
        if (audioRoot) {
            const playerWrapper = audioRoot.querySelector('[data-audio-transcription-player]');
            const initialUrl = playerWrapper?.getAttribute('data-initial-audio');
            if (playerWrapper && initialUrl) {
                audioTranscription.renderPlayer(playerWrapper, initialUrl);
            }
        }

        scrollReveal.refresh(target);
    });
});
